import { client, getToken } from "./client";

export class DataScienceApi {
  static async getAllClientsKpi(organizationId: string) {
    try {
      const response = await client.get(
        `/api/datascience/dashboard/fidelity/kpi-all-clients?organization_id=${organizationId}`,
        {
          headers: {
            Authorization: getToken(),
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error fetching all clients KPI:", error);
      throw error;
    }
  }

  static async getKpiActiveClients(
    organizationId: string,
    range: { startDate: string; endDate: string }
  ) {
    try {
      const response = await client.get(
        `/api/datascience/dashboard/fidelity/kpi-active_clients?organization_id=${organizationId}&starting_date=${range.startDate}&ending_date=${range.endDate}`,
        {
          headers: {
            Authorization: getToken(),
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error fetching KPI Active Clients:", error);
      throw error;
    }
  }

  static async getProfitabilityActiveClientsRaw(
    organizationId: string,
    range: { startDate: string; endDate: string }
  ) {
    try {
      const response = await client.get(
        `/api/datascience/dashboard/fidelity/profitability-active_clients-raw?organization_id=${organizationId}&starting_date=${range.startDate}&ending_date=${range.endDate}`,
        {
          headers: {
            Authorization: getToken(),
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error fetching Profitability Active Clients Raw:", error);
      throw error;
    }
  }
}
